export default "<p>contact-suggestion works!</p>\n";